import { METHODS } from 'utils/constants/methods'

export const INFORMATIVE_ERRORS = [
  { method: METHODS.GET, url: '/activities/activityStatus' },
  { method: METHODS.PATCH, url: '/results/teacherComment' },
  { method: METHODS.GET, url: '/resources/mauthor' },
  { method: METHODS.POST, url: '/userBooks/audioPlayed' },
  { method: METHODS.POST, url: '/thirdPartyLinkVisited' },
  { method: METHODS.GET, url: '/thirdPartyLinkVisited' },
  { method: METHODS.GET, url: '/htmlBookmarks' },
  { method: METHODS.PUT, url: '/htmlBookmarks' },
  { method: METHODS.GET, url: '/userFlags' },
  { method: METHODS.PUT, url: '/userFlags' },
  { method: METHODS.GET, url: '/userPreferences' },
  { method: METHODS.PUT, url: '/userPreferences' },
  { method: METHODS.POST, url: '/userPreferences' },
  { method: METHODS.POST, url: '/chatSession' },
  { method: METHODS.PUT, url: '/bookmarks' },
  { method: METHODS.GET, url: '/audioPlayed' },
  { method: METHODS.GET, url: '/interactions' },
]

export const ALERT_ERRORS = [
  { method: METHODS.GET, url: '/results' },
  { method: METHODS.GET, url: '/attempts' },
  { method: METHODS.GET, url: '/highlights' },
]

export const SNACKBAR_ERRORS = [
  { method: METHODS.POST, url: '/attempts' },
  { method: METHODS.PATCH, url: '/attempts' },
  { method: METHODS.GET, url: '/simpleActivityDetail' },
  { method: METHODS.POST, url: '/chatSession' },
  { method: METHODS.POST, url: '/highlights' },
  { method: METHODS.DELETE, url: '/highlights' },
  { method: METHODS.PATCH, url: '/highlights' },
]
